import type { Dayjs } from "dayjs";
import { IUser, AuthState } from "./auth";
import { normalizeResetEmail } from "./password-reset-flow";

export type AuthAction =
  | { type: "SET_LOADING" }
  | { type: "SET_USER"; payload: { user: IUser; token: string } }
  | { type: "LOGOUT" }
  | { type: "SET_FORGOT_PASSWORD_EMAIL"; payload: string }
  | { type: "SET_FORGOT_PASSWORD_VERIFICATION_CODE"; payload: string }
  | { type: "CLEAR_PASSWORD_RESET" }
  | {
      type: "SET_RESET_CODE_RESEND_AVAILABLE_AT";
      payload: { email: string; availableAt: Dayjs };
    }
  | {
      type: "SET_IMPERSONATION";
      payload: { user: IUser };
    }
  | { type: "CLEAR_IMPERSONATION" };

export const authReducer = (
  state: AuthState,
  action: AuthAction,
): AuthState => {
  switch (action.type) {
    case "SET_LOADING":
      return { ...state, isLoading: true };
    case "SET_USER":
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        isAuthenticated: true,
        isLoading: false,
      };
    case "LOGOUT":
      return {
        user: null,
        token: null,
        isAuthenticated: false,
        isLoading: false,
        forgotPasswordEmail: null,
        forgotPasswordVerificationCode: null,
        resetCodeResendAvailableAt: {},
        isImpersonating: false,
        impersonatedUser: null,
      };
    case "SET_FORGOT_PASSWORD_EMAIL":
      return { ...state, forgotPasswordEmail: action.payload };
    case "SET_FORGOT_PASSWORD_VERIFICATION_CODE":
      return { ...state, forgotPasswordVerificationCode: action.payload };
    case "CLEAR_PASSWORD_RESET":
      return {
        ...state,
        forgotPasswordEmail: null,
        forgotPasswordVerificationCode: null,
        resetCodeResendAvailableAt: {},
      };
    case "SET_RESET_CODE_RESEND_AVAILABLE_AT":
      return {
        ...state,
        resetCodeResendAvailableAt: {
          ...state.resetCodeResendAvailableAt,
          [normalizeResetEmail(action.payload.email)]:
            action.payload.availableAt,
        },
      };
    case "SET_IMPERSONATION":
      return {
        ...state,
        isImpersonating: true,
        impersonatedUser: action.payload.user,
      };
    case "CLEAR_IMPERSONATION":
      return {
        ...state,
        isImpersonating: false,
        impersonatedUser: null,
      };
    default:
      return state;
  }
};
